import React from 'react';
import { View } from 'react-native';
import { ColorTokens, ShimmerIconSizeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import Icon from '../icon/Icon';
const ShimmerIcon = ({ name, icon, size = ShimmerIconSizeTokens.XXXXXL, borderColor = ColorTokens.Grey_Milk_1, bgColor = ColorTokens.Grey_Milk_1, padding = SizeTypeTokens.SM, }) => {
    const theme = ThemeProvider.getTheme();
    const sizeValue = theme.shimmerIcon[size];
    const borderColorValue = theme.colors[borderColor];
    const bgColorValue = theme.colors[bgColor];
    const viewStyleProps = React.useMemo(() => ({
        height: sizeValue,
        width: sizeValue,
        borderRadius: sizeValue,
        backgroundColor: bgColorValue,
        borderColor: borderColorValue,
        borderWidth: borderColor ? 1 : 0,
    }), [bgColorValue, borderColorValue, sizeValue]);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                height: 180,
                width: 180,
                backgroundColor: '#F9FAFB',
                borderRadius: 180,
                borderColor: '#F9FAFB',
                borderWidth: 1,
            } },
            React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    // padding: "auto",
                    // paddingLeft: 10,
                    paddingTop: '25%',
                } },
                React.createElement(Icon, { ...icon })))));
};
export default React.memo(ShimmerIcon);
export { ShimmerIcon };
